module.exports = __webpack_public_path__ + "img/file-earmark-arrow-up.11bf1875.svg";